module.exports = __webpack_public_path__ + "static/media/0_2019_11_23.a2d89cf1.jpg";